import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { startCase, zip, isEmpty } from 'lodash';
import Fetchable from '~/commons/components/util/Fetchable';

import env from '~/commons/config/env';
import { useTranslation } from 'react-i18next';
import Page from '../../layout/Page';
import Scroll from '../../layout/Scroll';
import Html from '../../../../commons/components/util/Html';
import Board from '../../layout/Board';
import RankingsSmry from '../../mods/RankingsSmry';
import ProfileSmry from '../../mods/ProfileSmry';
import { calCoords } from './DashBoardHelper';

const domain = window.location.origin;

const PageDashboard = () => {
  const [currentStage, setCurrentStage] = useState({});
  const [width, setWidth] = useState();
  const isMobile = width <= 768;

  const path = 'M448.496 46.0003C412 34.5001 31.5024 -29.4996 67.5026 147.5C86.4959 240.884 401.326 217.244 448.496 252C524.5 308.002 493.45 411.167 327.501 418.502C146.503 426.502 73.574 439 52.9977 519.002C-5.00065 744.502 297 631.5 481.5 658C507.998 663.167 551.396 713.1 512.996 779.5C474.596 845.9 293.164 832 199.997 832C142.997 832 35.9942 832 26.9979 893.5C15.0029 975.5 92.4979 992 175.498 1000.5C241.898 1007.3 347.333 1003.33 419.5 1000.5';
  const { i18n, t } = useTranslation();
  const navigate = useNavigate();

  useEffect(() => {
    setWidth(window.innerWidth);
    const callback = () => {
      setWidth(window.innerWidth);
    };
    window.addEventListener('resize', callback);

    return () => window.removeEventListener('resize', callback);
  }, []);

  return (
    <Page card={null}>
      <Fetchable
        req={[
          { url: '/api/users/self' },
          { url: '/api/views/u', params: { key: 'rules' } },
          {
            url: '/api/rankings',
            params: { limit: 3, sort: { rank: 1, username: 1 } },
          },
          { url: '/api/levels' },
          {
            url: '/api/stages/listStage',
            params: env.lowMode ? { difficulty: 'low' } : {},
          },
        ]}
      >
        {([user, rulesView, { rows: rankings }, { rows: levels }, stages]) => {
          const modifyStage = [
            ...stages
              .filter((s) => s?._id)
              .map((s) => {
                const pic = s.path?.[0] ? `${domain}/uploads/${s?.path[0]}` : '/assets/img/default_roadIcon.png';
                return {
                  ...s,
                  href: `/game/stages${s._id}${
                    env.lowMode ? `/low/${s.firstRef}` : ''
                  }`,
                  pic,
                  size: 100,
                };
              }),
            {
              _id: '/Ranking',
              href: '/game/rankings',
              pic: `/assets/img/${
                i18n.language === 'en' ? 'book_en.png' : 'book_cn.png'
              }`,
              size: 200,
            },
          ];
          const displayArray = zip(calCoords(path, modifyStage.length), modifyStage);
          return (
            <div className="container">
              <div className="row gy-4">
                <div className="col-md">
                  <Scroll axis="y">
                    {isMobile && !isEmpty(currentStage) && currentStage._id !== '/Ranking' && (
                      <Board className="mb-3">
                        <div className="text-center">
                          <img
                            src={currentStage.pic}
                            alt=""
                            style={{ width: '50px', height: '50px' }}
                          />
                        </div>
                        <div className="text-center">
                          {startCase(i18n.pickLng(currentStage.name))}
                        </div>
                        <div className="text-center">
                          <button
                            className="btn fw-bold btn-rock-3 fontBorder"
                            type="button"
                            onClick={() => navigate(currentStage.href)}
                          >
                            {t('pg.game.start')}
                          </button>
                        </div>
                      </Board>
                    )}
                    <div className="road">
                      <svg
                        width="100%"
                        height="100%"
                        viewBox={isMobile ? '0 -20 560 1200' : '0 -20 600 1200'}
                        fill="none"
                      >
                        <path d={path} stroke="#805014" strokeWidth="50" />
                        {displayArray.map((v, i) => {
                          const [coord, stage] = v;
                          return (
                            <React.Fragment key={i + stage}>
                              {!isMobile && (
                                <text
                                  className="fontBorder"
                                  x={coord.x}
                                  y={coord.y + stage.size / 1.5}
                                  textAnchor="middle"
                                  fill="white"
                                  style={{
                                    textTransform: 'uppercase',
                                    fontSize: '20px',
                                  }}
                                  strokeWidth="5"
                                  strokeLinejoin="round"
                                  strokeLinecap="round"
                                >
                                    {stage._id !== '/Ranking' ? i18n.pickLng(stage.name) : ''}
                                </text>
                              )}
                              <Link
                                to={stage.href}
                                onClick={(e) => {
                                  if (isMobile && currentStage._id !== '/Ranking') {
                                    setCurrentStage(stage);
                                    e.preventDefault();
                                  }
                                }}
                              >
                                <image
                                  href={stage.pic}
                                  width={stage.size}
                                  height={stage.size}
                                  x={coord.x - stage.size / 2}
                                  y={coord.y - stage.size / 2}
                                />
                              </Link>
                            </React.Fragment>
                          );
                        })}
                      </svg>
                    </div>
                  </Scroll>
                </div>

                <div className="col-lg-5 col-lg-3">
                  {/* profile */}
                  <div className="mb-4">
                    <Board>
                      <ProfileSmry levels={levels} user={user} />
                    </Board>
                  </div>

                  {/* rules */}
                  <div className="mb-4">
                    <Board style={{ height: '25vh', overflow: 'hidden auto' }}>
                      <h2 className="fw-bold">
                        {i18n.pickLng(rulesView.title)}
                      </h2>
                      <Html>{i18n.pickLng(rulesView.body)}</Html>
                    </Board>
                  </div>

                  {/* rankings */}
                  <div className="mb-4">
                    <Board>
                      <RankingsSmry rankings={rankings} />
                    </Board>
                  </div>
                </div>
              </div>
            </div>
          );
        }}
      </Fetchable>
    </Page>
  );
};

export default PageDashboard;
